// extracted by mini-css-extract-plugin
export default {"commentsWrapper":"commentsWrapper---i3vud","addCommentBtn":"addCommentBtn---czhnE"};